import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "~/lib/utils"

const sectionHeaderVariants = cva("h-section-header", {
  variants: {
    size: {
      default: "",
      sm: "h-section-header--sm",
    },
  },
  defaultVariants: {
    size: "default",
  },
})

export interface SectionHeaderProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title">, VariantProps<typeof sectionHeaderVariants> {
  title: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
}

const SectionHeader = React.forwardRef<HTMLDivElement, SectionHeaderProps>(
  ({ className, size, title, subtitle, actions, children, ...props }, ref) => (
    <div ref={ref} className={cn(sectionHeaderVariants({ size }), className)} {...props}>
      <div className="h-section-header__content">
        <h2 className="h-section-header__heading">{title}</h2>
        {subtitle ? <p className="h-section-header__description">{subtitle}</p> : null}
      </div>
      {actions || children ? <div className="h-section-header__actions">{actions ?? children}</div> : null}
    </div>
  ),
)
SectionHeader.displayName = "SectionHeader"

export { SectionHeader }
